
<template>
  <div id="nav">
    <div id="nav-num">
      <div class="head">
        <div class="name">
          <div class="oimg">
            <img src="../assets/img/logo.png" alt />
          </div>
          <div class="spa">e博视智能电柜研发系统</div>
        </div>
        <div class="tatel">
          <div class="miti">
            <i class="el-icon-warning"></i>
          </div>
          <div class="mixin">t1进线</div>
        </div>
      </div>
      <div class="num">
        <div class="timerNav">
          <div class="year">{{ dateFormat(date) }}</div>
          <div class="time">{{ timerdate(date) }}</div>
        </div>
        <div
          class="home-item"
          v-for="(item, index) in list"
          :key="index"
          v-on:click="addClass(index)"
          v-bind:class="{ bgColors: index == current }"
        >
          <router-link :to="item.path">
            <div class="home-click">
              <div class="displayhome">
                <img :src="item.img1" alt v-if="index != current" />
                <img :src="item.img2" alt v-else />
                <p>{{ item.data }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div style="margin-left: 23px">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //时间
      date: new Date(),
      current: 0,
      list: [
        {
          id: 0,
          data: "运行概览",
          path: "/About",
          img1: require("../assets/img/gailan_nor.png"),
          img2: require("../assets/img/gailan_sel.png"),
        },
        {
          id: 1,
          data: "进线监测",
          path: "/ova",
          img1: require("../assets/img/shujujiance_nor.png"),
          img2: require("../assets/img/shujujiance_sel.png"),
        },
        {
          id: 2,
          data: "一次图模",
          path: "/FirstDiagram",
          img1: require("../assets/img/yicitumo_nor.png"),
          img2: require("../assets/img/yicitumo_sel.png"),
        },
        {
          id: 3,
          data: "事件记录",
          path: "/Cinema",
          img1: require("../assets/img/shijianjilu_nor.png"),
          img2: require("../assets/img/shijianjilu_sel.png"),
        },
      ],
    };
  },
  watch: {
    "$route.path": function (to) {
      switch (to) {
        case "/About":
          this.current = 0;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/ova":
          this.current = 1;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/Cinema":
          this.current = 3;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/FirstDiagram":
          this.current = 2;
          sessionStorage.setItem("isSelect", this.current);
          break;
      }
    },
  },
  created() {
    window.sessionStorage.setItem("token", "VrMakerToken");
    this.routerClickNave();
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.date = new Date(); // 修改数据date
    }, 1000);
    this.current = sessionStorage.getItem("isSelect")
      ? sessionStorage.getItem("isSelect")
      : "";
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    window.sessionStorage.removeItem("isSelect");
  },
  methods: {
    routerClickNave() {
      switch (this.$route.path) {
        case "/About":
          this.current = 0;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/Ova":
          this.current = 1;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/Cinema":
          this.current = 3;
          sessionStorage.setItem("isSelect", this.current);
          break;
        case "/FirstDiagram":
          this.current = 2;
          sessionStorage.setItem("isSelect", this.current);
          break;
      }
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      // 拼接
      return year + "-" + month + "-" + day;
    },
    timerdate(time) {
      var date = new Date(time);
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return hours + ":" + minutes + ":" + seconds;
    },
    addClass(index) {
      this.current = index ? index : 0;

      sessionStorage.setItem("isSelect", this.current);
    },
  },
};
</script>
<style lang="less" scoped>
#nav {
  width: 100%;
  height: 100%;
  .head {
    width: 100%;
    height: 48px;
    display: flex;
    margin-bottom: 24px;
    .name {
      width: 440px;
      height: 100%;
      background: #ffffff;
      display: flex;
      padding: 12px 17px 0 24px;
      .spa {
        width: 252px;
        font-size: 22px;
        font-weight: 400;
        color: #333333;
        margin-left: 17px;
        font-weight: 400;
        line-height: 24px;
      }
      .oimg {
        width: 24px;
        height: 24px;
      }
    }
    .tatel {
      width: 560px;
      height: 48px;
      background: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.01);
      padding: 12px 0 12px 24px;
      box-shadow: 0px 3px 14px 0px rgba(3, 13, 24, 0.26);
      border-radius: 0px 0px 8px 8px;
      display: flex;
      align-items: center;
      text-align: center;
      .miti {
        width: 22px;
        height: 22px;
        i {
          font-size: 22px;
          color: chocolate;
        }
      }
      .mixin {
        margin-left: 18px;
        font-size: 24px;
        font-weight: 400;
        margin-top: -2px;
        color: #666666;
      }
    }
  }
  .num {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    background-image: url(../assets/img/bgc.png);
  }
  .timerNav {
    width: 373px;
    display: flex;
    line-height: 68px;
    padding: 0 0 0 65px;
    .year {
      // width: 110px;
      height: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
    }
    .time {
      margin-left: 34px;
      width: 90px;
      height: 18px;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .home-item {
    display: flex;
    font-weight: bold;
    color: #2c3e50;
  }
  .home-click {
    width: 268px;
    height: 68px;
    font-size: 24px;
    font-weight: 300;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;

    text-shadow: 0px 1px 2px rgba(14, 5, 10, 0.6);
    //  background-image: url(../assets/img/613ju.png);
    .displayhome {
      display: flex;
      justify-content: space-between;
      width: 145px;
      //  justify-content: center;
      align-items: center;
    }
  }

  .bgColors {
    width: 268px;
    height: 68px;
    background-image: linear-gradient(
      rgba(31, 29, 29, 0.6) ; rgba(137, 141, 145, 0.5) ; rgba(31, 29, 29, 0.6)
    );
    // box-shadow:90px 50px 100px #020202;
    box-shadow: 3px 4px 5px #020202, -2px 4px 12px #020202;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
